import React from 'react';

const DatenschutzPage = () => (
  <main style={{ padding: '2rem', maxWidth: '1000px', margin: '0 auto', whiteSpace: 'pre-line' }}>
    <h1>Datenschutzerklärung</h1>
    <p>
Personenbezogene Daten (nachfolgend zumeist nur „Daten“ genannt) werden von
uns nur im Rahmen der Erforderlichkeit sowie zum Zwecke der Bereitstellung eines
funktionsfähigen und nutzerfreundlichen Internetauftritts, inklusive seiner Inhalte und
der dort angebotenen Leistungen, verarbeitet.
Gemäß Art. 4 Ziffer 1. der Verordnung (EU) 2016/679, also der Datenschutz-
Grundverordnung (nachfolgend nur „DSGVO“ genannt), gilt als „Verarbeitung“ jeder
mit oder ohne Hilfe automatisierter Verfahren ausgeführter Vorgang oder jede solche
Vorgangsreihe im Zusammenhang mit personenbezogenen Daten, wie das Erheben,
das Erfassen, die Organisation, das Ordnen, die Speicherung, die Anpassung oder
Veränderung, das Auslesen, das Abfragen, die Verwendung, die Offenlegung durch
Übermittlung, Verbreitung oder eine andere Form der Bereitstellung, den Abgleich
oder die Verknüpfung, die Einschränkung, das Löschen oder die Vernichtung.
Mit der nachfolgenden Datenschutzerklärung informieren wir Sie insbesondere über
Art, Umfang, Zweck, Dauer und Rechtsgrundlage der Verarbeitung
personenbezogener Daten, soweit wir entweder allein oder gemeinsam mit anderen
über die Zwecke und Mittel der Verarbeitung entscheiden. Zudem informieren wir Sie
nachfolgend über die von uns zu Optimierungszwecken sowie zur Steigerung der
Nutzungsqualität eingesetzten Fremdkomponenten, soweit hierdurch Dritte Daten in
wiederum eigener Verantwortung verarbeiten.
Unsere Datenschutzerklärung ist wie folgt gegliedert:
1. Informationen über uns als Verantwortliche
II. Rechte der Nutzer und Betroffenen
III. Informationen zur Datenverarbeitung
2. Informationen über uns als Verantwortliche
Verantwortlicher Anbieter dieses Internetauftritts im datenschutzrechtlichen Sinne ist:
[Firma]
Chiara, Körner
Lodenweg 6
59581, Warstein
Telefon: +491784590988
E-Mail: ckorner32@gmail.com
1. Rechte der Nutzer und Betroffenen
Mit Blick auf die nachfolgend noch näher beschriebene Datenverarbeitung haben die
Nutzer und Betroffenen das Recht
• auf Bestätigung, ob sie betreffende Daten verarbeitet werden, auf Auskunft
über die verarbeiteten Daten, auf weitere Informationen über die
Datenverarbeitung sowie auf Kopien der Daten (vgl. auch Art. 15 DSGVO);
• auf Berichtigung oder Vervollständigung unrichtiger bzw. unvollständiger
Daten (vgl. auch Art. 16 DSGVO);
• auf unverzügliche Löschung der sie betreffenden Daten (vgl. auch Art. 17
DSGVO), oder, alternativ, soweit eine weitere Verarbeitung gemäß Art. 17
Abs. 3 DSGVO erforderlich ist, auf Einschränkung der Verarbeitung nach
Maßgabe von Art. 18 DSGVO;
• auf Erhalt der sie betreffenden und von ihnen bereitgestellten Daten und auf
Übermittlung dieser Daten an andere Anbieter/Verantwortliche (vgl. auch Art.
20 DSGVO);
• auf Beschwerde gegenüber der Aufsichtsbehörde, sofern sie der Ansicht sind,
dass die sie betreffenden Daten durch den Anbieter unter Verstoß gegen
datenschutzrechtliche Bestimmungen verarbeitet werden (vgl. auch Art. 77
DSGVO).
Darüber hinaus ist der Anbieter dazu verpflichtet, alle Empfänger, denen gegenüber
Daten durch den Anbieter offengelegt worden sind, über jedwede Berichtigung oder
Löschung von Daten oder die Einschränkung der Verarbeitung, die aufgrund der
Artikel 16, 17 Abs. 1, 18 DSGVO erfolgt, zu unterrichten. Diese Verpflichtung besteht
jedoch nicht, soweit diese Mitteilung unmöglich oder mit einem unverhältnismäßigen
Aufwand verbunden ist. Unbeschadet dessen hat der Nutzer ein Recht auf Auskunft
über diese Empfänger.
Ebenfalls haben die Nutzer und Betroffenen nach Art. 21 DSGVO das Recht auf
Widerspruch gegen die künftige Verarbeitung der sie betreffenden Daten,
sofern die Daten durch den Anbieter nach Maßgabe von Art. 6 Abs. 1 lit. f)
DSGVO verarbeitet werden. Insbesondere ist ein Widerspruch gegen die
Datenverarbeitung zum Zwecke der Direktwerbung statthaft.
III. Informationen zur Datenverarbeitung
Ihre bei Nutzung unseres Internetauftritts verarbeiteten Daten werden gelöscht oder
gesperrt, sobald der Zweck der Speicherung entfällt, der Löschung der Daten keine
gesetzlichen Aufbewahrungspflichten entgegenstehen und nachfolgend keine
anderslautenden Angaben zu einzelnen Verarbeitungsverfahren gemacht werden.
Cookie Manager
Zur Einholung einer Einwilligung zum Einsatz von technisch nicht notwendigen
Cookies auf der Website, setzt der Anbieter einen Cookie-Manager ein.
Bei dem Aufruf der Website wird ein Cookie mit den Einstellungsinformationen auf
dem Endgerät des Nutzers abgelegt, sodass bei einem weiteren Besuch die Abfrage
in Bezug auf die Einwilligung nicht erfolgen muss.
Das Cookie ist erforderlich um eine rechtskonforme Einwilligung des Nutzers
einzuholen.
Die Installation der Cookies kann der Nutzer durch Einstellungen seines Browsers
verhindern bzw. beenden.
Cookies
1. a) Sitzungs-Cookies/Session-Cookies
Wir verwenden mit unserem Internetauftritt sog. Cookies. Cookies sind kleine
Textdateien oder andere Speichertechnologien, die durch den von Ihnen
eingesetzten Internet-Browser auf Ihrem Endgerät ablegt und gespeichert werden.
Durch diese Cookies werden im individuellen Umfang bestimmte Informationen von
Ihnen, wie beispielsweise Ihre Browser- oder Standortdaten oder Ihre IP-Adresse,
verarbeitet.
Durch diese Verarbeitung wird unser Internetauftritt benutzerfreundlicher, effektiver
und sicherer, da die Verarbeitung bspw. die Wiedergabe unseres Internetauftritts in
unterschiedlichen Sprachen oder das Angebot einer Warenkorbfunktion ermöglicht.
Rechtsgrundlage dieser Verarbeitung ist Art. 6 Abs. 1 lit b.) DSGVO, sofern diese
Cookies Daten zur Vertragsanbahnung oder Vertragsabwicklung verarbeitet werden.
Falls die Verarbeitung nicht der Vertragsanbahnung oder Vertragsabwicklung dient,
liegt unser berechtigtes Interesse in der Verbesserung der Funktionalität unseres
Internetauftritts. Rechtsgrundlage ist in dann Art. 6 Abs. 1 lit. f) DSGVO.
Mit Schließen Ihres Internet-Browsers werden diese Session-Cookies gelöscht.
1. b) Drittanbieter-Cookies
Gegebenenfalls werden mit unserem Internetauftritt auch Cookies von
Partnerunternehmen, mit denen wir zum Zwecke der Werbung, der Analyse oder der
Funktionalitäten unseres Internetauftritts zusammenarbeiten, verwendet.
Die Einzelheiten hierzu, insbesondere zu den Zwecken und den Rechtsgrundlagen
der Verarbeitung solcher Drittanbieter-Cookies, entnehmen Sie bitte den
nachfolgenden Informationen.
1. c) Beseitigungsmöglichkeit
Sie können die Installation der Cookies durch eine Einstellung Ihres Internet-
Browsers verhindern oder einschränken. Ebenfalls können Sie bereits gespeicherte
Cookies jederzeit löschen. Die hierfür erforderlichen Schritte und Maßnahmen
hängen jedoch von Ihrem konkret genutzten Internet-Browser ab. Bei Fragen
benutzen Sie daher bitte die Hilfefunktion oder Dokumentation Ihres Internet-
Browsers oder wenden sich an dessen Hersteller bzw. Support. Bei sog. Flash-
Cookies kann die Verarbeitung allerdings nicht über die Einstellungen des Browsers
unterbunden werden. Stattdessen müssen Sie insoweit die Einstellung Ihres Flash-
Players ändern. Auch die hierfür erforderlichen Schritte und Maßnahmen hängen von
Ihrem konkret genutzten Flash-Player ab. Bei Fragen benutzen Sie daher bitte
ebenso die Hilfefunktion oder Dokumentation Ihres Flash-Players oder wenden sich
an den Hersteller bzw. Benutzer-Support.
Sollten Sie die Installation der Cookies verhindern oder einschränken, kann dies
allerdings dazu führen, dass nicht sämtliche Funktionen unseres Internetauftritts
vollumfänglich nutzbar sind.
Kontaktanfragen / Kontaktmöglichkeit
Sofern Sie per Kontaktformular oder E-Mail mit uns in Kontakt treten, werden die
dabei von Ihnen angegebenen Daten zur Bearbeitung Ihrer Anfrage genutzt. Die
Angabe der Daten ist zur Bearbeitung und Beantwortung Ihre Anfrage erforderlich –
ohne deren Bereitstellung können wir Ihre Anfrage nicht oder allenfalls eingeschränkt
beantworten.
Rechtsgrundlage für diese Verarbeitung ist Art. 6 Abs. 1 lit. b) DSGVO.
Ihre Daten werden gelöscht, sofern Ihre Anfrage abschließend beantwortet worden
ist und der Löschung keine gesetzlichen Aufbewahrungspflichten entgegenstehen,
wie bspw. bei einer sich etwaig anschließenden Vertragsabwicklung.
Für die Abwicklung der Kontaktabfragen wird der Drittanbieterdienst Calendly
eingesetzt. Die gemeinsame Verantwortlichkeit haben wir in einer Vereinbarung
bezüglich der jeweiligen Verpflichtungen im Sinne der DSGVO geregelt. Diese
Vereinbarung, aus der sich die gegenseitigen Verpflichtungen ergeben, ist unter dem
folgenden Link abrufbar:
https://calendly.com/dpa
Newsletter
Falls Sie sich für unseren kostenlosen Newsletter anmelden, werden die von Ihnen
hierzu abgefragten Daten, also Ihre E-Mail-Adresse sowie – optional – Ihr Name und
Ihre Anschrift, an uns übermittelt. Gleichzeitig speichern wir die IP-Adresse des
Internetanschlusses von dem aus Sie auf unseren Internetauftritt zugreifen sowie
Datum und Uhrzeit Ihrer Anmeldung. Im Rahmen des weiteren Anmeldevorgangs
werden wir Ihre Einwilligung in die Übersendung des Newsletters einholen, den Inhalt
konkret beschreiben und auf diese Datenschutzerklärung verwiesen. Die dabei
erhobenen Daten verwenden wir ausschließlich für den Newsletter-Versand – sie
werden deshalb insbesondere auch nicht an Dritte weitergegeben.
Rechtsgrundlage hierbei ist Art. 6 Abs. 1 lit. a) DSGVO.
Die Einwilligung in den Newsletter-Versand können Sie gemäß Art. 7 Abs. 3 DSGVO
jederzeit mit Wirkung für die Zukunft widerrufen. Hierzu müssen Sie uns lediglich
über Ihren Widerruf in Kenntnis setzen oder den in jedem Newsletter enthaltenen
Abmeldelink betätigen.
Serverdaten
Aus technischen Gründen, insbesondere zur Gewährleistung eines sicheren und
stabilen Internetauftritts, werden Daten durch Ihren Internet-Browser an uns bzw. an
unseren Webspace-Provider übermittelt. Mit diesen sog. Server-Logfiles werden u.a.
Typ und Version Ihres Internetbrowsers, das Betriebssystem, die Website, von der
aus Sie auf unseren Internetauftritt gewechselt haben (Referrer URL), die Website(s)
unseres Internetauftritts, die Sie besuchen, Datum und Uhrzeit des jeweiligen Zugriffs
sowie die IP-Adresse des Internetanschlusses, von dem aus die Nutzung unseres
Internetauftritts erfolgt, erhoben.
Diese so erhobenen Daten werden vorrübergehend gespeichert, dies jedoch nicht
gemeinsam mit anderen Daten von Ihnen.
Diese Speicherung erfolgt auf der Rechtsgrundlage von Art. 6 Abs. 1 lit. f) DSGVO.
Unser berechtigtes Interesse liegt in der Verbesserung, Stabilität, Funktionalität und
Sicherheit unseres Internetauftritts.
Die Daten werden spätestens nach sieben Tage wieder gelöscht, soweit keine
weitere Aufbewahrung zu Beweiszwecken erforderlich ist. Andernfalls sind die Daten
bis zur endgültigen Klärung eines Vorfalls ganz oder teilweise von der Löschung
ausgenommen.
Vertragsabwicklung
Die von Ihnen zur Inanspruchnahme unseres Waren- und/oder
Dienstleistungsangebots übermittelten Daten werden von uns zum Zwecke der
Vertragsabwicklung verarbeitet und sind insoweit erforderlich. Vertragsschluss und
Vertragsabwicklung sind ohne Bereitstellung Ihrer Daten nicht möglich.
Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 lit. b) DSGVO.
Wir löschen die Daten mit vollständiger Vertragsabwicklung, müssen dabei aber die
steuer- und handelsrechtlichen Aufbewahrungsfristen beachten.
Im Rahmen der Vertragsabwicklung geben wir Ihre Daten an das mit der
Warenlieferung beauftragte Transportunternehmen oder an den Finanzdienstleister
weiter, soweit die Weitergabe zur Warenauslieferung oder zu Bezahlzwecken
erforderlich ist.
Rechtsgrundlage für die Weitergabe der Daten ist dann Art. 6 Abs. 1 lit. b) DSGVO.
Ablefy
Wir verwenden Ablefy, einen Dienst von Ablefy GmbH, um Zahlungsabwicklungen für
unsere Produkte und Dienstleistungen durchzuführen. Ablefy ermöglicht es uns,
sichere und effiziente Transaktionen für Sie als Kunden zu gewährleisten. Bitte
beachten Sie, dass während des Zahlungsvorgangs personenbezogene Daten
erhoben und verarbeitet werden können. Ablefy erhebt und verarbeitet
Informationen, wie Ihren Namen, Ihre E-Mail-Adresse und Zahlungsdetails, um die
Zahlungstransaktion abzuschließen. Ablefy ist bekannt für seine hohe
Sicherheitsstandards und seine Einhaltung der geltenden
Datenschutzbestimmungen. Durch die Nutzung unserer Produkte und
Dienstleistungen stimmen Sie der Erfassung und Verarbeitung Ihrer Daten durch
elopage zu. Wir haben vertragliche Vereinbarungen mit Ablefy getroffen, um
sicherzustellen, dass Ihre Daten gemäß den geltenden Datenschutzbestimmungen
geschützt werden. Für weitere Informationen über die Datenschutzpraktiken von
elopage und um Ihre Rechte in Bezug auf Ihre personenbezogenen Daten
auszuüben, lesen Sie bitte die Datenschutzrichtlinie von Ablefy auf deren Website.
https://myablefy.com/privacy?locale=de
Einbindung von sevDesk
Wir nutzen für die Abwicklung unserer Buchhaltung und Zahlungsprozesse den
Dienst sevDesk der sevDesk GmbH, Hauptstraße 115, 77652 Offenburg. In diesem
Zusammenhang werden personenbezogene Daten, insbesondere Rechnungs- und
Zahlungsinformationen, an sevDesk übermittelt und dort verarbeitet. Die
Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO zur Erfüllung
unseres Vertragsverhältnisses sowie aufgrund unseres berechtigten Interesses
gemäß Art. 6 Abs. 1 lit. f DSGVO an einer effizienten und sicheren Abwicklung
unserer Buchhaltungsprozesse.
Weitere Informationen zur Datenverarbeitung durch sevDesk entnehmen Sie bitte der
Datenschutzerklärung des Anbieters:
https://sevdesk.de/sicherheit-datenschutz/
Facebook
Zur Bewerbung unserer Produkte und Leistungen sowie zur Kommunikation mit
Interessenten oder Kunden betreiben wir eine Firmenpräsenz auf der Plattform
Facebook.
Auf dieser Social-Media-Plattform sind wir gemeinsam mit der Meta Platforms Ireland
Limited, 4 Grand Canal Square, Dublin 2, Irland, verantwortlich.
Der Datenschutzbeauftragte von Facebook kann über ein Kontaktformular erreicht
werden:
https://www.facebook.com/help/contact/540977946302970
Die gemeinsame Verantwortlichkeit haben wir in einer Vereinbarung bezüglich der
jeweiligen Verpflichtungen im Sinne der DSGVO geregelt. Diese Vereinbarung, aus
der sich die gegenseitigen Verpflichtungen ergeben, ist unter dem folgenden Link
abrufbar:
https://www.facebook.com/legal/terms/page_controller_addendum
Rechtsgrundlage für die dadurch erfolgende und nachfolgend wiedergegebene
Verarbeitung von personenbezogenen Daten ist Art. 6 Abs. 1 lit. f DSGVO. Unser
berechtigtes Interesse besteht an der Analyse, der Kommunikation sowie dem
Absatz und der Bewerbung unserer Produkte und Leistungen.
Rechtsgrundlage kann auch eine Einwilligung des Nutzers gemäß Art. 6 Abs. 1 lit. a
DSGVO gegenüber dem Plattformbetreiber sein. Die Einwilligung hierzu kann der
Nutzer nach Art. 7 Abs. 3 DSGVO jederzeit durch eine Mitteilung an den
Plattformbetreiber für die Zukunft widerrufen.
Bei dem Aufruf unseres Onlineauftritts auf der Plattform Facebook werden von der
Facebook Ireland Ltd. als Betreiberin der Plattform in der EU Daten des Nutzers (z.B.
persönliche Informationen, IP-Adresse etc.) verarbeitet.
Diese Daten des Nutzers dienen zu statistischen Informationen über die
Inanspruchnahme unserer Firmenpräsenz auf Facebook. Die Facebook Ireland Ltd.
nutzt diese Daten zu Marktforschungs- und Werbezwecken sowie zur Erstellung von
Profilen der Nutzer. Anhand dieser Profile ist es der Facebook Ireland Ltd.
beispielsweise möglich, die Nutzer innerhalb und außerhalb von Facebook
interessenbezogen zu bewerben. Ist der Nutzer zum Zeitpunkt des Aufrufes in
seinem Account auf Facebook eingeloggt, kann die Facebook Ireland Ltd. zudem die
Daten mit dem jeweiligen Nutzerkonto verknüpfen.
Im Falle einer Kontaktaufnahme des Nutzers über Facebook werden die bei dieser
Gelegenheit eingegebenen personenbezogenen Daten des Nutzers zur Bearbeitung
der Anfrage genutzt. Die Daten des Nutzers werden bei uns gelöscht, sofern die
Anfrage des Nutzers abschließend beantwortet wurde und keine gesetzlichen
Aufbewahrungspflichten, wie z.B. bei einer anschließenden Vertragsabwicklung,
entgegenstehen.
Zur Verarbeitung der Daten werden von der Facebook Ireland Ltd. ggf. auch Cookies
gesetzt.
Sollte der Nutzer mit dieser Verarbeitung nicht einverstanden sein, so besteht die
Möglichkeit, die Installation der Cookies durch eine entsprechende Einstellung des
Browsers zu verhindern. Bereits gespeicherte Cookies können ebenfalls jederzeit
gelöscht werden. Die Einstellungen hierzu sind vom jeweiligen Browser abhängig.
Bei Flash-Cookies lässt sich die Verarbeitung nicht über die Einstellungen des
Browsers unterbinden, sondern durch die entsprechende Einstellung des Flash-
Players. Sollte der Nutzer die Installation der Cookies verhindern oder einschränken,
kann dies dazu führen, dass nicht sämtliche Funktionen von Facebook vollumfänglich
nutzbar sind.
Näheres zu den Verarbeitungstätigkeiten, deren Unterbindung und zur Löschung der
von Facebook verarbeiteten Daten finden sich in der Datenrichtlinie von Facebook:
https://www.facebook.com/privacy/explanation
Es ist nicht ausgeschlossen, dass die Verarbeitung durch die Meta Platforms Ireland
Limited auch über die Meta Platforms, Inc., 1601 Willow Road, Menlo Park, California
94025 in den USA erfolgt.
Instagram
Zur Bewerbung unserer Produkte und Leistungen sowie zur Kommunikation mit
Interessenten oder Kunden betreiben wir eine Firmenpräsenz auf der Plattform
Instagram.
Auf dieser Social-Media-Plattform sind wir gemeinsam mit der Meta Platforms Ireland
Limited, 4 Grand Canal Square, Dublin 2, Irland, verantwortlich.
Der Datenschutzbeauftragte von Instagram kann über ein Kontaktformular erreicht
werden:
https://www.facebook.com/help/contact/540977946302970
Die gemeinsame Verantwortlichkeit haben wir in einer Vereinbarung bezüglich der
jeweiligen Verpflichtungen im Sinne der DSGVO geregelt. Diese Vereinbarung, aus
der sich die gegenseitigen Verpflichtungen ergeben, ist unter dem folgenden Link
abrufbar:
https://www.facebook.com/legal/terms/page_controller_addendum
Rechtsgrundlage für die dadurch erfolgende und nachfolgend wiedergegebene
Verarbeitung von personenbezogenen Daten ist Art. 6 Abs. 1 lit. f DSGVO. Unser
berechtigtes Interesse besteht an der Analyse, der Kommunikation sowie dem
Absatz und der Bewerbung unserer Produkte und Leistungen.
Rechtsgrundlage kann auch eine Einwilligung des Nutzers gemäß Art. 6 Abs. 1 lit. a
DSGVO gegenüber dem Plattformbetreiber sein. Die Einwilligung hierzu kann der
Nutzer nach Art. 7 Abs. 3 DSGVO jederzeit durch eine Mitteilung an den
Plattformbetreiber für die Zukunft widerrufen.
Bei dem Aufruf unseres Onlineauftritts auf der Plattform Instagram werden von der
Facebook Ireland Ltd. als Betreiberin der Plattform in der EU Daten des Nutzers (z.B.
persönliche Informationen, IP-Adresse etc.) verarbeitet.
Diese Daten des Nutzers dienen zu statistischen Informationen über die
Inanspruchnahme unserer Firmenpräsenz auf Instagram. Die Facebook Ireland Ltd.
nutzt diese Daten zu Marktforschungs- und Werbezwecken sowie zur Erstellung von
Profilen der Nutzer. Anhand dieser Profile ist es der Facebook Ireland Ltd.
beispielsweise möglich, die Nutzer innerhalb und außerhalb von Instagram
interessenbezogen zu bewerben. Ist der Nutzer zum Zeitpunkt des Aufrufes in
seinem Account auf Instagram eingeloggt, kann die Facebook Ireland Ltd. zudem die
Daten mit dem jeweiligen Nutzerkonto verknüpfen.
Im Falle einer Kontaktaufnahme des Nutzers über Instagram werden die bei dieser
Gelegenheit eingegebenen personenbezogenen Daten des Nutzers zur Bearbeitung
der Anfrage genutzt. Die Daten des Nutzers werden bei uns gelöscht, sofern die
Anfrage des Nutzers abschließend beantwortet wurde und keine gesetzlichen
Aufbewahrungspflichten, wie z.B. bei einer anschließenden Vertragsabwicklung,
entgegenstehen.
Zur Verarbeitung der Daten werden von der Facebook Ireland Ltd. ggf. auch Cookies
gesetzt.
Sollte der Nutzer mit dieser Verarbeitung nicht einverstanden sein, so besteht die
Möglichkeit, die Installation der Cookies durch eine entsprechende Einstellung des
Browsers zu verhindern. Bereits gespeicherte Cookies können ebenfalls jederzeit
gelöscht werden. Die Einstellungen hierzu sind vom jeweiligen Browser abhängig.
Bei Flash-Cookies lässt sich die Verarbeitung nicht über die Einstellungen des
Browsers unterbinden, sondern durch die entsprechende Einstellung des Flash-
Players. Sollte der Nutzer die Installation der Cookies verhindern oder einschränken,
kann dies dazu führen, dass nicht sämtliche Funktionen von Facebook vollumfänglich
nutzbar sind.
Näheres zu den Verarbeitungstätigkeiten, deren Unterbindung und zur Löschung der
von Instagram verarbeiteten Daten finden sich in der Datenrichtlinie von Instagram:
https://help.instagram.com/519522125107875
Es ist nicht ausgeschlossen, dass die Verarbeitung durch die Facebook Ireland Ltd.
auch über die Meta Platforms, Inc., 1601 Willow Road, Menlo Park, California 94025
in den USA erfolgt.
TikTok
Zur Bewerbung unserer Produkte und Leistungen sowie zur Kommunikation mit
Interessenten oder Kunden betreiben wir eine Firmenpräsenz auf der Plattform
TikTok.
Auf dieser Social-Media-Plattform sind wir gemeinsam mit der TikTok Technology
Limited, 10 Earlsfort Terrace, Dublin, D02 T380, Irland, verantwortlich.
Die Datenschutzerklärung von TikTok kann über folgende URL eingesehen werden:
https://www.tiktok.com/legal/page/eea/privacy-policy/
Rechtsgrundlage für die dadurch erfolgende und nachfolgend wiedergegebene
Verarbeitung von personenbezogenen Daten ist Art. 6 Abs. 1 lit. f DSGVO. Unser
berechtigtes Interesse besteht an der Analyse, der Kommunikation sowie dem
Absatz und der Bewerbung unserer Produkte und Leistungen.
Rechtsgrundlage kann auch eine Einwilligung des Nutzers gemäß Art. 6 Abs. 1 lit. a
DSGVO gegenüber dem Plattformbetreiber sein. Die Einwilligung hierzu kann der
Nutzer nach Art. 7 Abs. 3 DSGVO jederzeit durch eine Mitteilung an den
Plattformbetreiber für die Zukunft widerrufen.
Diese Daten des Nutzers dienen zu statistischen Informationen über die
Inanspruchnahme unserer Firmenpräsenz auf TikTok. Die TikTok Technology
Limited nutzt diese Daten zu Marktforschungs- und Werbezwecken sowie zur
Erstellung von Profilen der Nutzer. Anhand dieser Profile ist es der TikTok
Technology Limited beispielsweise möglich, die Nutzer innerhalb und außerhalb von
TikTok interessenbezogen zu bewerben. Ist der Nutzer zum Zeitpunkt des Aufrufes in
seinem Account auf TikTok eingeloggt, kann die TikTok Technology Limited zudem
die Daten mit dem jeweiligen Nutzerkonto verknüpfen.
Im Falle einer Kontaktaufnahme des Nutzers über TikTok werden die bei dieser
Gelegenheit eingegebenen personenbezogenen Daten des Nutzers zur Bearbeitung
der Anfrage genutzt. Die Daten des Nutzers werden bei uns gelöscht, sofern die
Anfrage des Nutzers abschließend beantwortet wurde und keine gesetzlichen
Aufbewahrungspflichten, wie z.B. bei einer anschließenden Vertragsabwicklung,
entgegenstehen.
Zur Verarbeitung der Daten werden von der TikTok Technology Limited ggf. auch
Cookies gesetzt.
Sollte der Nutzer mit dieser Verarbeitung nicht einverstanden sein, so besteht die
Möglichkeit, die Installation der Cookies durch eine entsprechende Einstellung des
Browsers zu verhindern. Bereits gespeicherte Cookies können ebenfalls jederzeit
gelöscht werden. Die Einstellungen hierzu sind vom jeweiligen Browser abhängig.
Bei Flash-Cookies lässt sich die Verarbeitung nicht über die Einstellungen des
Browsers unterbinden, sondern durch die entsprechende Einstellung des Flash-
Players. Sollte der Nutzer die Installation der Cookies verhindern oder einschränken,
kann dies dazu führen, dass nicht sämtliche Funktionen von TikTok vollumfänglich
nutzbar sind.
Näheres zu den Verarbeitungstätigkeiten, deren Unterbindung und zur Löschung der
von Instagram verarbeiteten Daten finden sich in der Datenrichtlinie von Instagram:
YouTube
Wir unterhalten bei YouTube eine Onlinepräsenz um unser Unternehmen sowie
unsere Leistungen zu präsentieren und mit Kunden/Interessenten zu kommunizieren.
YouTube ist ein Service der Google Ireland Limited, Gordon House, Barrow Street,
Dublin 4, Irland, ein Tochterunternehmen der Google LLC, 1600 Amphitheatre
Parkway, Mountain View, CA 94043 USA.
Insofern weisen wir darauf hin, dass die Möglichkeit besteht, dass Daten der Nutzer
außerhalb der Europäischen Union, insbesondere in den USA, verarbeitet werden.
Hierdurch können gesteigerte Risiken für die Nutzer insofern bestehen, als dass z.B.
der spätere Zugriff auf die Nutzerdaten erschwert werden kann. Auch haben wir
keinen Zugriff auf diese Nutzerdaten. Die Zugriffsmöglichkeit liegt ausschließlich bei
YouTube.
Die Datenschutzhinweise von YouTube finden Sie unter
https://policies.google.com/privacy
YouTube
Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland, ein
Tochterunternehmen der Google LLC, 1600 Amphitheatre Parkway, Mountain View,
CA 94043 USA
Datenschutzerklärung: https://policies.google.com/privacy
Google Analytics
In unserem Internetauftritt setzen wir Google Analytics ein. Hierbei handelt es sich
um einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow
Street, Dublin 4, Irland, nachfolgend nur „Google“ genannt.
Der Dienst Google Analytics dient zur Analyse des Nutzungsverhaltens unseres
Internetauftritts. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO. Unser berechtigtes
Interesse liegt in der Analyse, Optimierung und dem wirtschaftlichen Betrieb unseres
Internetauftritts.
Nutzungs- und nutzerbezogene Informationen, wie bspw. IP-Adresse, Ort, Zeit oder
Häufigkeit des Besuchs unseres Internetauftritts, werden dabei an einen Server von
Google in den USA übertragen und dort gespeichert. Allerdings nutzen wir Google
Analytics mit der sog. Anonymisierungsfunktion. Durch diese Funktion kürzt Google
die IP-Adresse schon innerhalb der EU bzw. des EWR.
Die so erhobenen Daten werden wiederum von Google genutzt, um uns eine
Auswertung über den Besuch unseres Internetauftritts sowie über die dortigen
Nutzungsaktivitäten zur Verfügung zu stellen. Auch können diese Daten genutzt
werden, um weitere Dienstleistungen zu erbringen, die mit der Nutzung unseres
Internetauftritts und der Nutzung des Internets zusammenhängen.
Google gibt an, Ihre IP-Adresse nicht mit anderen Daten zu verbinden. Zudem hält
Google unter
https://www.google.com/intl/de/policies/privacy/partners
weitere datenschutzrechtliche Informationen für Sie bereit, so bspw. auch zu den
Möglichkeiten, die Datennutzung zu unterbinden.
Zudem bietet Google unter
https://tools.google.com/dlpage/gaoptout?hl=de
ein sog. Deaktivierungs-Add-on nebst weiteren Informationen hierzu an. Dieses Add-
on lässt sich mit den gängigen Internet-Browsern installieren und bietet Ihnen
weitergehende Kontrollmöglichkeit über die Daten, die Google bei Aufruf unseres
Internetauftritts erfasst. Dabei teilt das Add-on dem JavaScript (ga.js) von Google
Analytics mit, dass Informationen zum Besuch unseres Internetauftritts nicht an
Google Analytics übermittelt werden sollen. Dies verhindert aber nicht, dass
Informationen an uns oder an andere Webanalysedienste übermittelt werden. Ob
und welche weiteren Webanalysedienste von uns eingesetzt werden, erfahren Sie
natürlich ebenfalls in dieser Datenschutzerklärung.
Google-Maps
In unserem Internetauftritt setzen wir Google Maps zur Darstellung unseres
Standorts sowie zur Erstellung einer Anfahrtsbeschreibung ein. Es handelt sich
hierbei um einen Dienst der Google Ireland Limited, Gordon House, Barrow Street,
Dublin 4, Irland, nachfolgend nur „Google“ genannt.
Um die Darstellung bestimmter Schriften in unserem Internetauftritt zu ermöglichen,
wird bei Aufruf unseres Internetauftritts eine Verbindung zu dem Google-Server in
den USA aufgebaut.
Sofern Sie die in unseren Internetauftritt eingebundene Komponente Google Maps
aufrufen, speichert Google über Ihren Internet-Browser ein Cookie auf Ihrem
Endgerät. Um unseren Standort anzuzeigen und eine Anfahrtsbeschreibung zu
erstellen, werden Ihre Nutzereinstellungen und -daten verarbeitet. Hierbei können wir
nicht ausschließen, dass Google Server in den USA einsetzt.
Im Falle einer von Ihnen erteilten Einwilligung für diese Verarbeitung ist
Rechtsgrundlage Art. 6 Abs. 1 lit. a DSGVO. Rechtsgrundlage kann auch Art. 6 Abs.
1 lit. f DSGVO sein. Unser berechtigtes Interesse liegt in der Optimierung der
Funktionalität unseres Internetauftritts.
Durch die so hergestellte Verbindung zu Google kann Google ermitteln, von welcher
Website Ihre Anfrage gesendet worden ist und an welche IP-Adresse die
Anfahrtsbeschreibung zu übermitteln ist.
Sofern Sie mit dieser Verarbeitung nicht einverstanden sind, haben Sie die
Möglichkeit, die Installation der Cookies durch die entsprechenden Einstellungen in
Ihrem Internet-Browser zu verhindern. Einzelheiten hierzu finden Sie vorstehend
unter dem Punkt „Cookies“.
Zudem erfolgt die Nutzung von Google Maps sowie der über Google Maps erlangten
Informationen nach den Google-
Nutzungsbedingungen https://policies.google.com/terms?gl=DE&hl=de und
den Geschäftsbedingungen für Google
Mapshttps://www.google.com/intl/de_de/help/terms_maps.html.
Überdies bietet Google unter
https://adssettings.google.com/authenticated
https://policies.google.com/privacy
weitergehende Informationen an.
YouTube
In unserem Internetauftritt setzen wir YouTube ein. Hierbei handelt es sich um ein
Videoportal der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4,
Irland, nachfolgend nur „YouTube“ genannt.
Wir nutzen YouTube im Zusammenhang mit der Funktion „Erweiterter
Datenschutzmodus“, um Ihnen Videos anzeigen zu können. Im Falle einer von Ihnen
erteilten Einwilligung für diese Verarbeitung ist Rechtsgrundlage Art. 6 Abs. 1 lit. a
DSGVO. Rechtsgrundlage kann auch Art. 6 Abs. 1 lit. f DSGVO sein. Unser
berechtigtes Interesse liegt in der Qualitätsverbesserung unseres Internetauftritts.
Die Funktion „Erweiterter Datenschutzmodus“ bewirkt laut Angaben von YouTube,
dass die nachfolgend noch näher bezeichneten Daten nur dann an den Server von
YouTube übermittelt werden, wenn Sie ein Video auch tatsächlich starten.
Ohne diesen „Erweiterten Datenschutz“ wird eine Verbindung zum Server von
YouTube in den USA hergestellt, sobald Sie eine unserer Internetseiten, auf der ein
YouTube-Video eingebettet ist, aufrufen.
Diese Verbindung ist erforderlich, um das jeweilige Video auf unserer Internetseite
über Ihren Internet-Browser darstellen zu können. Im Zuge dessen wird YouTube
zumindest Ihre IP-Adresse, das Datum nebst Uhrzeit sowie die von Ihnen besuchte
Internetseite erfassen und verarbeiten. Zudem wird eine Verbindung zu dem
Werbenetzwerk „DoubleClick“ von Google hergestellt.
Sollten Sie gleichzeitig bei YouTube eingeloggt sein, weist YouTube die
Verbindungsinformationen Ihrem YouTube-Konto zu. Wenn Sie das verhindern
möchten, müssen Sie sich entweder vor dem Besuch unseres Internetauftritts bei
YouTube ausloggen oder die entsprechenden Einstellungen in Ihrem YouTube-
Benutzerkonto vornehmen.
Zum Zwecke der Funktionalität sowie zur Analyse des Nutzungsverhaltens speichert
YouTube dauerhaft Cookies über Ihren Internet-Browser auf Ihrem Endgerät. Falls
Sie mit dieser Verarbeitung nicht einverstanden sind, haben Sie die Möglichkeit, die
Speicherung der Cookies durch eine Einstellung in Ihrem Internet-Browsers zu
verhindern. Nähere Informationen hierzu finden Sie vorstehend unter „Cookies“.
Weitergehende Informationen über die Erhebung und Nutzung von Daten sowie Ihre
diesbezüglichen Rechte und Schutzmöglichkeiten hält Google in den unter
https://policies.google.com/privacy
abrufbaren Datenschutzhinweisen bereit.
Einsatz von PayPal als Zahlungsart
Sollten Sie sich im Rahmen Ihres Bestellvorgangs für eine Bezahlung mit dem
Online-Zahlungsdienstleister PayPal entscheiden, werden im Rahmen der so
ausgelösten Bestellung Ihre Kontaktdaten an PayPal übermittelt. PayPal ist ein
Angebot der PayPal (Europe) S.à.r.l. & Cie. S.C.A., 22-24 Boulevard Royal, L-2449
Luxembourg. PayPal übernimmt dabei die Funktion eines Online-
Zahlungsdienstleisters sowie eines Treuhänders und bietet Käuferschutzdienste an.
Bei den an PayPal übermittelten personenbezogenen Daten handelt es sich zumeist
um Vorname, Nachname, Adresse, Telefonnummer, IP-Adresse, E-Mail-Adresse,
oder andere Daten, die zur Bestellabwicklung erforderlich sind, als auch Daten, die
im Zusammenhang mit der Bestellung stehen, wie Anzahl der Artikel, Artikelnummer,
Rechnungsbetrag und Steuern in Prozent, Rechnungsinformationen, usw.
Diese Übermittelung ist zur Abwicklung Ihrer Bestellung mit der von Ihnen
ausgewählten Zahlungsart notwendig, insbesondere zur Bestätigung Ihrer Identität,
zur Administration Ihrer Zahlung und der Kundenbeziehung. Die Übermittlung Ihrer
Daten an PayPal erfolgt daher auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO.
Bitte beachten Sie jedoch: Personenbezogenen Daten können seitens PayPal auch
an Leistungserbringer, an Subunternehmer oder andere verbundene Unternehmen
weitergegeben werden, soweit dies zur Erfüllung der vertraglichen Verpflichtungen
aus Ihrer Bestellung erforderlich ist oder die personenbezogenen Daten im Auftrag
verarbeitet werden sollen.
Abhängig von der über PayPal ausgewählten Zahlungsart, z.B. Rechnung oder
Lastschrift, werden die an PayPal übermittelten personenbezogenen Daten von
PayPal an Wirtschaftsauskunfteien übermittelt. Diese Übermittlung dient der
Identitäts- und Bonitätsprüfung in Bezug auf die von Ihnen getätigte Bestellung. Um
welche Auskunfteien es sich hierbei handelt und welche Daten von PayPal allgemein
erhoben, verarbeitet, gespeichert und weitergegeben werden, entnehmen Sie der
Datenschutzerklärung von PayPal unter
https://www.paypal.com/de/webapps/mpp/ua/privacy-full
Einsatz von Sofortüberweisung als Zahlungsart
Sollten Sie sich im Rahmen Ihres Bestellvorgangs für eine Bezahlung mit dem
Online-Zahlungsdienstleister Sofortüberweisung entscheiden, werden im Rahmen
der so ausgelösten Bestellung Ihre Kontaktdaten an Sofortüberweisung übermittelt.
Sofortüberweisung ist ein Angebot der SOFORT GmbH, Theresienhöhe 12, 80339
München, Deutschland. Sofortüberweisung übernimmt dabei die Funktion eines
Online-Zahlungsdienstleisters, der eine bargeldlose Zahlung von Produkten und
Dienstleistungen im Internet ermöglicht.
Bei den an Sofortüberweisung übermittelten personenbezogenen Daten handelt es
sich zumeist um Vorname, Nachname, Adresse, Telefonnummer, IP-Adresse, E-
Mail-Adresse, oder andere Daten, die zur Bestellabwicklung erforderlich sind, als
auch Daten, die im Zusammenhang mit der Bestellung stehen, wie Anzahl der
Artikel, Artikelnummer, Rechnungsbetrag und Steuern in Prozent,
Rechnungsinformationen, usw.
Diese Übermittelung ist zur Abwicklung Ihrer Bestellung mit der von Ihnen
ausgewählten Zahlungsart notwendig, insbesondere zur Bestätigung Ihrer Identität,
zur Administration Ihrer Zahlung und der Kundenbeziehung. Die Übermittlung Ihrer
Daten an SOFORT GmbH erfolgt daher auf Grundlage von Art. 6 Abs. 1 lit. b
DSGVO.
Bitte beachten Sie jedoch: Personenbezogenen Daten können seitens
Sofortüberweisung auch an Leistungserbringer, an Subunternehmer oder andere
verbundene Unternehmen weitergegeben werden, soweit dies zur Erfüllung der
vertraglichen Verpflichtungen aus Ihrer Bestellung erforderlich ist oder die
personenbezogenen Daten im Auftrag verarbeitet werden sollen.
Unter Umständen werden die an Sofortüberweisung übermittelten
personenbezogenen Daten von Sofortüberweisung an Wirtschaftsauskunfteien
übermittelt. Diese Übermittlung dient der Identitäts- und Bonitätsprüfung in Bezug auf
die von Ihnen getätigte Bestellung.
Welche Datenschutzgrundsätze Sofortüberweisung bei der Verarbeitung Ihrer Daten
zugrunde legt, können Sie den Datenschutzhinweisen entnehmen, die Ihnen
während des Zahlungsvorgangs von Sofortüberweisung angezeigt werden.
Bei weiteren Fragen zur Verwendung Ihrer personenbezogenen Daten können Sie
sich an Sofortüberweisung per E-Mail (datenschutz@sofort.com) oder schriftlich
(SOFORT GmbH, Datenschutz, Theresienhöhe 12, 80339 München) wenden.
WhatsApp Kontaktaufnahme
Zur Kontaktaufnahme ermöglicht der Anbieter dem Kunden unter anderem die
Kontaktmöglichkeit über den Messenger-Dienst WhatsApp. WhatsApp ist ein Dienst
der WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin
2, Irland, nachfolgend WhatsApp, eine Tochtergesellschaft von Facebook.
Durch die Kommunikation des Nutzers mit dem Anbieter über WhatsApp erhält
sowohl der Anbieter, als auch WhatsApp die Mobilrufnummer des Nutzers und die
Information, dass der Nutzer den Anbieter kontaktiert hat.
Die vorgenannten Daten werden von WhatsApp auch an Server von Facebook in
den USA weitergeleitet und von WhatsApp und Facebook entsprechend der
WhatsApp-Datenschutzrichtlinie verarbeitet, was auch die Verarbeitung zu deren
eigenen Zwecken, wie der Verbesserung des WhatsApp-Dienstes, beinhaltet.
_____________________
Die USA verfügen gegenwärtig nach Ansicht der
Datenschutzaufsichtsbehörden allerdings nicht über ein angemessenes
Datenschutzniveau. Es bestehen allerdings sogenannte
Standardvertragsklauseln:
https://faq.whatsapp.com/general/about-standard-contractual-clauses
Jedoch sind dies privatrechtliche Vereinbarungen und haben daher keine
direkte Auswirkung auf die Zugriffsmöglichkeiten der Behörden in den USA.
_____________________
Näheres zum Zweck und Umfang der Datenerhebung und der weiteren Verarbeitung
dieser Daten durch WhatsApp und Facebook sowie diesbezügliche Rechte und
Einstellungsmöglichkeiten zum Schutz der Privatsphäre sind in der
Datenschutzrichtlinie von WhatsApp enthalten:
https://www.whatsapp.com/legal/#privacy-policy.
Rechtsgrundlage dieser Verarbeitungen und der Übermittlung an WhatsApp ist Art. 6
Abs. 1 S. 1 b. DSGVO, soweit die Kontaktaufnahme eine bestehende
Vertragsbeziehung betrifft oder der Anbahnung einer solchen Vertragsbeziehung
dient. Sollte die Kontaktaufnahme nicht aufgrund der vorstehenden Zwecke erfolgen,
ist Rechtsgrundlage Art. 6 Abs. 1 lit. f DSGVO. Das berechtigte Interesse des
Anbieters besteht an der Verbesserung der Servicequalität.
    </p>
  </main>
);

export default DatenschutzPage;
